import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { WebpayService } from 'src/app/project/services/webpay.service';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.css'],
})
export class ErrorComponent {
    parametros: any;
    constructor(private router: Router,
        private webpay: WebpayService,

        @Inject(DOCUMENT) private document: Document
    ) {
        this.data_error = this.router.getCurrentNavigation().extras.state;
    }

    data_error;

    ngOnInit(): void {
        this.parametros = JSON.parse(JSON.stringify(this.webpay.getQueryParams(window.location.href)));

    }

    async volver() {

        this.document.location.href = await this.webpay.setBotonVolver(this.parametros.uid, null);
    }

}
